if (!customElements.get('l-section-gallery')) {
	customElements.define(
		'l-section-gallery',
		class LTASectionWatchVideo extends HTMLElement {
			constructor() {
				super()
				this.currentPage = 1
				this.mediaPerPage = 12
				this.totalMedia = 0
			}

			connectedCallback() {
				// Elements
				this.galleryGridEl = this.querySelector('[data-gallery-cards]')
				this.allMediaEls = this.galleryGridEl.querySelectorAll('[data-media-card]')
				this.categoryTagEls = this.querySelectorAll('[data-category-tag]')

				// Data
				this.mediaPerPage = parseInt(this.dataset.mediaPerPage) || 12
				this.mediaLoadMore = parseInt(this.dataset.mediaLoadMore) || 4
				this.selectedCategoryTag = ''
				this.currentShowingProducts = this.mediaPerPage

				// Events
				this.handleTagClickEvent()

				window.addEventListener(
					'scroll',
					debounce(() => this.handleScroll(), 30)
				)
			}

			handleScroll() {
				const galleryBottom = this.galleryGridEl.getBoundingClientRect().bottom
				const windowBottom = window.innerHeight

				if (windowBottom + 500 >= galleryBottom) {
					this.loadMoreMedia()
				}
			}

			loadMoreMedia() {
				this.currentShowingProducts = this.currentShowingProducts + this.mediaLoadMore
				let cardCount = 0

				this.allMediaEls.forEach((mediaCardEl) => {
					const cardCategory = mediaCardEl.dataset.mediaCard
					let shouldShowCard = cardCount < this.currentShowingProducts

					if (this.selectedCategoryTag) {
						shouldShowCard = cardCount < this.currentShowingProducts && cardCategory === this.selectedCategoryTag
					}

					shouldShowCard && cardCount++

					mediaCardEl.classList.toggle('l-hidden', !shouldShowCard)

					debounce(() => {
						mediaCardEl.classList.toggle('is-active', shouldShowCard)
					}, 100)()
				})

				this.mutedAllVideos()
			}

			handleTagClickEvent() {
				this.categoryTagEls.forEach((categoryTagEl) => {
					categoryTagEl.addEventListener('click', () => {
						const categoryTag = categoryTagEl.dataset.categoryTag
						const isSelected = categoryTagEl.classList.contains('is-active')

						this.categoryTagEls.forEach((categoryTagEl) => {
							categoryTagEl.classList.remove('is-active')
						})

						categoryTagEl.classList.toggle('is-active', !isSelected)
						this.selectedCategoryTag = isSelected ? '' : categoryTag

						this.updateData(this.selectedCategoryTag)
						this.loadMoreMedia()
					})
				})
			}

			updateData(category) {
				this.selectedCategoryTag = category ? category : ''
				this.currentShowingProducts = this.mediaPerPage
			}

			mutedAllVideos() {
				this.videoEls = this.videoEls || this.querySelectorAll('video')

				this.videoEls.forEach((video) => {
					video.muted = true
				})
			}
		}
	)
}

/************************************************************************************

COMPONENT: VIDEO CARD

*************************************************************************************/
if (!customElements.get('l-video-card')) {
	customElements.define(
		'l-video-card',
		class LTASectionVideoCard extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				this.videoEl = this.querySelector('video')
				this.videoPlayBtnEl = this.querySelector('[data-play-btn]')

				if (!this.videoEl || !this.videoPlayBtnEl) return

				this.videoPlayBtnEl.addEventListener('click', () => {
					const isPlaying = this.videoPlayBtnEl.classList.contains('is-playing')

					if (isPlaying) {
						this.videoEl.muted = true
						this.videoEl.pause()
						this.videoPlayBtnEl.classList.remove('is-playing')
					} else {
						this.videoEl.muted = false
						this.videoEl.play()
						this.videoPlayBtnEl.classList.add('is-playing')
					}
				})
			}
		}
	)
}

